import * as React from 'react';
import { Head } from '@inertiajs/react';

interface SEOBlockProps {
  appUrl: string;
}

export function SEOBlock({ appUrl }: SEOBlockProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Abasto Virtual',
    description: 'Proveedor mayorista de frutas y verduras para verdulerías en Córdoba. Delivery, predicciones de precios semanales, facturación formal y cuenta corriente.',
    url: `${appUrl}/verdulerias`,
    telephone: '+5493512026384',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Córdoba',
      addressRegion: 'Córdoba',
      addressCountry: 'AR',
    },
    areaServed: {
      '@type': 'City',
      name: 'Córdoba',
    },
    priceRange: '$$',
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="verdu-seo">
        <style>{`
          .verdu-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .verdu-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .verdu-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .verdu-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0 0 12px;
          }
          .verdu-seo p:last-child {
            margin: 0;
          }
        `}</style>
        <div className="verdu-seo-inner">
          <h2>Proveedor mayorista de frutas y verduras para verdulerías en Córdoba</h2>
          <p>
            Abasto Virtual es el proveedor mayorista que abastece verdulerías, fruterías y almacenes en Córdoba
            capital con frutas y verduras frescas, entrega en el local, facturación formal y precios competitivos.
          </p>
          <p>
            Ofrecemos predicciones semanales de precios basadas en clima, estacionalidad e ingreso de mercadería
            al Mercado de Abasto de Córdoba, para que puedas planificar tus costos de reposición sin sorpresas.
          </p>
        </div>
      </section>
    </>
  );
}
